<template>
  <el-dialog :visible.sync="bindCustomersDialog" width="80%" title="绑定客户">
    <el-form :model="queryParams">
      <el-row :gutter="20">
        <el-col :span="7">
          <el-form-item label="查询项：" label-width="100px">
            <el-select v-model="queryParams.column" placeholder="客户名称">
              <el-option label="客户名称" value="cusName"></el-option>
              <el-option label="联系人" value="ccContacts"></el-option>
              <el-option label="联系电话" value="ccPhone"></el-option>
              <el-option label="联系手机" value="ccMobile"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="productClass">
            <el-input v-model="params.value" placeholder="请输入关键词"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <el-form-item>
            <el-button type="primary" @click="onSearch">搜索</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-table
      ref="bindCustomertTableRef"
      :data="bindCustomerData"
      :header-cell-style="tableHeader"
      class="addProductModule"
      height="600"
      @row-click="handleRowClick"
      @selection-change="handleSelectionChange"
      element-loading-text="拼命加载中请稍后..."
      v-loading="loadingBindCustomerData"
      element-loading-spinner="el-icon-loading"
      border
    >
      <el-table-column type="selection" min-width="5"></el-table-column>
      <el-table-column prop="cusName" label="客户名称"></el-table-column>
      <el-table-column prop="ccContacts" label="联系人"></el-table-column>
      <el-table-column prop="ccPhone" label="联系电话"></el-table-column>
      <el-table-column prop="ccMobile" label="联系手机"></el-table-column>
      <el-table-column prop="bizProvince" label="经营地址"></el-table-column>
      <el-table-column prop="bizAddress" label="详细地址"></el-table-column>
    </el-table>
    <div class="pagination">
      <pagination
        :total="total"
        :currentPage="currentPage"
        :pageSize="pageSize"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      ></pagination>
    </div>
    <div style="text-align:right;">
      <el-button type="primary" @click="onSubmit">提 交</el-button>
      <el-button @click="onCancel">取 消</el-button>
    </div>
  </el-dialog>
</template>
<script>
import pagination from '@/components/pagination'
import {
  queryAllCustomerByLike,
  customerTemplateAdd
} from '@/api/customer/customerManage'
export default {
  components: {
    pagination
  },
  data () {
    return {
      bindCustomersDialog: false,
      bindCustomerData: [],
      custormerName: '',
      templateId: 0,
      total: 0,
      currentPage: 1, // 页码
      pageSize: 30, // 当前页数
      queryParams: {
        column: ''
      },
      params: {},
      checkList: [], // 列表选中的数据
      loadingBindCustomerData: false
    }
  },
  methods: {
    // 弹窗初始状态
    onInitial (val) {
      this.queryParams = {}
      this.params = {}
      this.templateId = val
      this.getCustomerList()
      this.bindCustomersDialog = true
    },
    // 客户列表
    getCustomerList () {
      this.loadingBindCustomerData = true
      const params = {
        criteriaVoList: this.$queryParams(this.queryParams, this.params),
        queryPageName: ''
      }
      queryAllCustomerByLike(this.currentPage, this.pageSize, params)
        .then((res) => {
          if (res.data.code === 200) {
            this.loadingBindCustomerData = false
            this.bindCustomerData = res.data.obj.records
            this.total = res.data.obj.total
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 提交
    onSubmit () {
      if (this.checkList === undefined || this.checkList.length <= 0) {
        this.$message.error('请选中移交员工')
        return
      }
      const customerId = []
      this.checkList.forEach((res) => {
        customerId.push(res.id)
      })
      customerTemplateAdd(this.templateId, customerId)
        .then((res) => {
          if (res.data.code === 200) {
            this.$message.success('绑定成功!')
            this.queryParams = {}
            this.params = {}
            this.bindCustomersDialog = false
            this.$emit('onUpdate')
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 搜索
    onSearch () {
      this.getCustomerList()
    },
    // 表头样式
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.getCustomerList()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getCustomerList()
    },
    // 列表选中的数据
    handleSelectionChange (val) {
      this.checkList = val
    },
    // 点击空白处选中
    handleRowClick (row, column, event) {
      this.$refs.bindCustomertTableRef.toggleRowSelection(row)
    },
    // 取消
    onCancel () {
      this.bindCustomersDialog = false
    }
  }
}
</script>
